import React, { FC } from 'react';
import { ICellRendererParams } from 'ag-grid-community';
import { CheckOutlined, HighlightOffOutlined } from '@mui/icons-material';
import variables from '../../../assets/styles/variables.module.scss';

const BooleanRenderer: FC<ICellRendererParams> = (props: ICellRendererParams) => {
    return <div className="flex-row center icon-renderer-cell">
        {props.value ? <CheckOutlined style={{ color: variables.color_green }}/> : <span></span>}
    </div>
};

export default BooleanRenderer;
